import { createStore } from 'vuex';
import inclusaoStore from './inclusao';
import tarefaStore from './tarefas';
import pesaveisStore from './pesaveis';

const store = createStore({
    modules: {
        inclusao: inclusaoStore,
        tarefas: tarefaStore,
        pesaveis: pesaveisStore,
    },
    state() {
        return {
            todosProdutos: null,
            todosProdutosPesaveis: null,
            codigoInclusao: null,
            numeroSync: 0,
        };
    },
    mutations: {
        setTodosProdutos(state, payload) {
            state.todosProdutos = payload;
        },
        setTodosProdutosPesaveis(state, payload) {
            state.todosProdutosPesaveis = payload;
        },
        setCodigoInclusao(state, payload) {
            state.codigoInclusao = payload;
        },
        plusNumeroSync(state) {
            state.numeroSync++;
        },
        minusNumeroSync(state) {
            state.numeroSync--;
        },
        resetNumeroSync(state) {
            state.numeroSync = 0;
        },
    },
    actions: {
        setTodosProdutos(context, payload) {
            context.commit('setTodosProdutos', payload);
        },
        setTodosProdutosPesaveis(context, payload) {
            context.commit('setTodosProdutosPesaveis', payload);
        },
        setCodigoInclusao(context, payload) {
            context.commit('setCodigoInclusao', payload);
        },
        plusNumeroSync(context) {
            context.commit('plusNumeroSync');
        },
        minusNumeroSync(context) {
            context.commit('minusNumeroSync');
        },
        resetNumeroSync(context) {
            context.commit('resetNumeroSync');
        },
    },
    getters: {
        getTodosProdutos(state) {
            return state.todosProdutos;
        },
        getTodosProdutosPesaveis(state) {
            return state.todosProdutosPesaveis;
        },
        getNumerosSync(state) {
            return state.numeroSync;
        },
        getCodigoInclusao(state) {
            return state.codigoInclusao;
        },
    },
});

export default store;
